// extracted by mini-css-extract-plugin
module.exports = {"liquiditypool":"liquidity-image_liquiditypool__2_hJ5","title":"liquidity-image_title__1FE1L","amount":"liquidity-image_amount__2Q6gT","daysUnit":"liquidity-image_daysUnit__22IxI"};